import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../../Layout";
import CoachAISessionReport from "../../containers/CoachAI/SessionReport";

export default function CoachAISessionReportPage() {
  const { sessionId } = useParams();

  return (
    <Layout>
      <CoachAISessionReport sessionId={sessionId} />
    </Layout>
  );
}



